"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorDataFromJSON = ErrorDataFromJSON;
exports.ErrorDataFromJSONTyped = ErrorDataFromJSONTyped;
exports.ErrorDataToJSON = ErrorDataToJSON;
exports.ErrorDataToJSONTyped = ErrorDataToJSONTyped;
const runtime_1 = require("../runtime");
function ErrorDataFromJSON(json) {
    return ErrorDataFromJSONTyped(json, false);
}
function ErrorDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
        'code': !(0, runtime_1.exists)(json, 'code') ? undefined : json['code'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'params': !(0, runtime_1.exists)(json, 'params') ? undefined : json['params'],
    };
}
function ErrorDataToJSON(value) {
    return ErrorDataToJSONTyped(value, false);
}
function ErrorDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'message': value.message,
        'code': value.code,
        'status': value.status,
        'type': value.type,
        'params': value.params,
    };
}
